import { encryptStorage } from '@/utils/storage';

export const setSelectedBusinessLine = (state, value) => {
  state.selectedBusinessLine = value;
  try {
    if (value) {
      encryptStorage.setItem('selectedBusinessLine', value);
    } else {
      encryptStorage.removeItem('selectedBusinessLine');
    }
  } catch (e) {
    // ignore storage errors (e.g. private mode)
  }
};

export const setCompanyFilter = (state, { key, value }) => {
  let currentFilters = state.companyFilter || "";
  const filterMap = new URLSearchParams(currentFilters);
  if (value === null) {
    filterMap.delete(key);
  } else {
    filterMap.set(key, value);
  }
  state.companyFilter = filterMap.toString();
  console.log("Nuevo filtro:", state.companyFilter);
};
export const setState = (state, { key, value }) => {
  state[key] = value;
};

export const patchInteractionCall = (state, call) => {
  const index = state.interactionCalls.results.findIndex((c) => c.id === call.id);
  if (index !== -1) state.interactionCalls.results.splice(index, 1, call);
};

export const setBusinessLinesDirty = (state, value) => {
  state.businessLinesDirty = value;
};
export const removeState = (state, { key, keySearch, value }) => {
  console.log("key---->:", key, "keySearch---->", keySearch, "value---->", value);
  state[key].data.results = state[key].data.results.filter(
    (item) => item[keySearch] !== value
  );
};

export const addEnty = (state, { key, value }) => {
  console.log("key---->:", key, "value---->", value);
  if (!state[key]) {
    state[key] = { data: { results: [] } };
  }
  if (!state[key].data) {
    state[key].data = { results: [] };
  }
  if (!Array.isArray(state[key].data.results)) {
    state[key].data.results = [];
  }
  state[key].data.results = [value, ...state[key].data.results];
};

export const updateState = (state, { key, keySearch, value, data }) => {
  console.log(key, keySearch, value);
  const isValidObject = (obj) => {
    return obj && typeof obj === "object" && Object.keys(obj).length > 0;
  };
  if (
    isValidObject(state[key]) &&
    state[key].data &&
    Array.isArray(state[key].data.results)
  ) {
    let index = state[key].data.results.findIndex(
      (item) => item[keySearch] === value
    );
    console.log("INDEX: ", index);
    state[key].data.results[index] = data;
  }
};

export const SET_FILTER = (state, { key, value }) => {
  state[key] = value;
  console.log('Filtro actualizado (directo):', key, '=', value);
};

export const setFilter = (state, { key, value, enty }) => {
  let currentFilters = state[enty] || "";
  const filterMap = new URLSearchParams(currentFilters);

  if (
    value === null ||
    value === "" ||
    (Array.isArray(value) && value.length === 0)
  ) {
    filterMap.delete(key);
  } else if (Array.isArray(value)) {
    filterMap.delete(key); // limpio el filtro previo
    value.forEach((v) => filterMap.append(key, v)); // genera ?users=1&users=2
  } else {
    filterMap.set(key, value);
  }

  state[enty] = filterMap.toString();
  console.log("Nuevo filtro:", state[enty]);
};

export const addDynamicFieldToInteraction = (
  state,
  { interactionId, campos }
) => {
  console.log("Adding dynamic fields to interaction:", interactionId, campos);
  const interaction = state.interactions.data?.results?.find(
    (i) => i.id === interactionId
  );
  if (interaction) {
    if (!Array.isArray(interaction.campos_dinamicos)) {
      interaction.campos_dinamicos = [];
    }
    interaction.campos_dinamicos = campos;
  }
};

export const removeInteractionFromStatus = (
  state,
  { key, statusId, interactionId }
) => {
  const status = state[key].data.data.find((s) => s.status_id === statusId);
  if (status) {
    status.interactions = status.interactions.filter(
      (interaction) => interaction.id !== interactionId
    );
  }
};
/**
 * Coloca una tarjeta en la columna de su `status_id` sin recargar el tablero
 * (`.claude/optimizacion_crm/`, M-9). Si ya estaba en el tablero se quita de
 * donde estuviera; en la misma columna conserva su posición (así una tarjeta
 * recién soltada se queda donde la dejó el arrastre) y en otra entra arriba.
 * `index` fuerza la posición (lo usa deshacer un arrastre).
 * Se trabaja con `splice` sobre los mismos arrays porque vuedraggable los
 * tiene enlazados por `:list`.
 */
export const placeInteractionOnBoard = (state, { key, interaction, index = null }) => {
  const columns = state[key]?.data?.data;
  if (!Array.isArray(columns)) return;
  let fromColumn = null;
  let fromIndex = -1;
  columns.forEach((column) => {
    const list = column.interactions || [];
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].id === interaction.id) {
        if (!fromColumn) {
          fromColumn = column;
          fromIndex = i;
        }
        list.splice(i, 1);
      }
    }
  });
  const destination = columns.find((column) => column.status_id === interaction.status_id);
  if (!destination) return;
  if (!Array.isArray(destination.interactions)) destination.interactions = [];
  const at = index ?? (destination === fromColumn ? fromIndex : 0);
  destination.interactions.splice(
    Math.max(0, Math.min(at, destination.interactions.length)),
    0,
    interaction
  );
};

/** Quita una tarjeta del tablero esté en la columna que esté. */
export const removeInteractionFromBoard = (state, { key, interactionId }) => {
  const columns = state[key]?.data?.data;
  if (!Array.isArray(columns)) return;
  columns.forEach((column) => {
    const list = column.interactions || [];
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].id === interactionId) list.splice(i, 1);
    }
  });
};

export const removeInteractionFromPhase = (
  state,
  { key, phaseId, interactionId }
) => {
  const status = state[key].data.data.find((s) => s.phase_id === phaseId);
  if (status) {
    status.interactions = status.interactions.filter(
      (interaction) => interaction.id !== interactionId
    );
  }
};
export const removeInteractionFromStage = (
  state,
  { key, stageId, interactionId }
) => {
  console.log("Removing interaction from stage:", key, stageId, interactionId);
  const status = state[key].data.data.find((s) => s.stage_id === stageId);
  if (status) {
    status.interactions = status.interactions.filter(
      (interaction) => interaction.id !== interactionId
    );
  }
};

export const addFile = (state, { data }) => {
  console.log("State: ", state.currentInteraction.data, "data: ", data);
  state.currentInteraction.data.attachments = [
    data,
    ...state.currentInteraction.data.attachments,
  ];
};
export const deleteFile = (state, { id }) => {
  console.log("State: ", state.currentInteraction.data, "ID: ", id);
  state.currentInteraction.data.attachments =
    state.currentInteraction.data.attachments.filter(
      (item) => item.id !== id
    );
};
export const SET_IS_REPORT_FORM = (state, isReportForm) => {
  state.isReportForm = isReportForm;
}

export const setTabInteractionActive = (state, tab) => {
  state.tabInteractionActive = tab;
}

// --- Alertas de asignación (`.claude/alertas_crm/`) ---

/** Cuántas alertas recibidas se guardan como máximo (las más nuevas). */
const MAX_ALERTAS = 150;

export const setAssignmentAlerts = (state, { recibidas = [], enviadas = [], unseenCount = null }) => {
  state.assignmentAlerts.recibidas = recibidas;
  state.assignmentAlerts.enviadas = enviadas;
  state.assignmentAlerts.unseenCount = unseenCount;
  state.assignmentAlerts.cargadas = true;
};
export const setAssignmentUnseenCount = (state, n) => {
  state.assignmentAlerts.unseenCount = n;
};
/** Apaga el aviso de estas tarjetas/filas (ids de gestión) sin recargar. */
export const markAssignmentRowsSeen = (state, ids) => {
  const nuevas = { ...state.assignmentAlerts.filasVistas };
  (ids || []).forEach((id) => {
    nuevas[id] = true;
  });
  state.assignmentAlerts.filasVistas = nuevas;
};
/** Vuelta atrás de lo anterior si `mark_seen/` falla. */
export const unmarkAssignmentRowSeen = (state, id) => {
  const nuevas = { ...state.assignmentAlerts.filasVistas };
  delete nuevas[id];
  state.assignmentAlerts.filasVistas = nuevas;
};
/** Ajuste optimista del contador de servidor (sin él, `null`, no hace nada). */
export const adjustAssignmentUnseenCount = (state, delta) => {
  if (state.assignmentAlerts.unseenCount == null || !delta) return;
  state.assignmentAlerts.unseenCount = Math.max(0, state.assignmentAlerts.unseenCount + delta);
};
export const setAssignmentAlertsLoading = (state, cargando) => {
  state.assignmentAlerts.cargando = cargando;
};
/** Una alerta nueva arriba. Si ya estaba (eco del socket), se reemplaza. */
export const prependAssignmentAlert = (state, alerta) => {
  const lista = state.assignmentAlerts.recibidas.filter((otra) => otra.id !== alerta.id);
  lista.unshift(alerta);
  state.assignmentAlerts.recibidas = lista.slice(0, MAX_ALERTAS);
};
/**
 * Cambia el estado de items concretos de las RECIBIDAS:
 * `cambios = [{ alertaId, id }]`. Lo usan marcar vista y su vuelta atrás.
 */
export const setAssignmentItemsEstado = (state, { cambios, estado, motivo }) => {
  const porAlerta = new Map();
  cambios.forEach(({ alertaId, id }) => {
    if (!porAlerta.has(alertaId)) porAlerta.set(alertaId, new Set());
    porAlerta.get(alertaId).add(String(id));
  });
  state.assignmentAlerts.recibidas.forEach((alerta) => {
    const ids = porAlerta.get(alerta.id);
    if (!ids) return;
    alerta.items.forEach((item) => {
      if (!ids.has(String(item.id))) return;
      item.estado = estado;
      if (motivo !== undefined) item.motivo = motivo;
    });
  });
};
/** Como máximo 3 avisos a la vez (el mockup): el más viejo sale. */
const MAX_TOASTS = 3;
let toastSeq = 0;
export const pushAssignmentToast = (state, toast) => {
  toastSeq += 1;
  state.assignmentToasts = [...state.assignmentToasts, { ...toast, id: `t${toastSeq}` }].slice(
    -MAX_TOASTS
  );
};
export const removeAssignmentToast = (state, id) => {
  state.assignmentToasts = state.assignmentToasts.filter((toast) => toast.id !== id);
};
export const assignmentArrived = (state, { ids = [], tipo = null, alertaId = null }) => {
  state.assignmentArrival = {
    seq: state.assignmentArrival.seq + 1,
    ids,
    tipo,
    alertaId,
  };
};

// --- FEXIA CRM chat (streaming real por WebSocket) ---
export const SET_CRM_CHAT_ID = (state, chatId) => {
  state.crmChat.chatId = chatId;
};
export const SET_CRM_MESSAGES = (state, messages) => {
  state.crmChat.messages = messages;
};
export const ADD_CRM_MESSAGE = (state, message) => {
  state.crmChat.messages.push(message);
};
export const APPEND_CRM_CHUNK = (state, { temporalId, text }) => {
  const msg = state.crmChat.messages.find((m) => m.id === temporalId);
  if (msg) msg.content += text;
};
export const FINALIZE_CRM_MESSAGE = (state, { temporalId, messageId }) => {
  const msg = state.crmChat.messages.find((m) => m.id === temporalId);
  if (msg) {
    msg.streaming = false;
    if (messageId !== undefined) msg.messageId = messageId;
  }
};
export const SET_CRM_STREAMING = (state, value) => {
  state.crmChat.isStreaming = value;
};
export const SET_CRM_PANEL_OPEN = (state, open) => {
  state.crmChat.isPanelOpen = open;
  // Al abrir el panel se limpia el badge de no leídos.
  if (open) state.crmChat.unreadCount = 0;
};
export const INCREMENT_CRM_UNREAD = (state) => {
  state.crmChat.unreadCount += 1;
};
// ---------------------------------------------------------------------------
// Campana del CRM (FC-743) — `.claude/crm_notificaciones/`
// ---------------------------------------------------------------------------

/** Guarda un grupo ya normalizado por `bellApi`. `grupo` es toDo | news | followUp. */
export const setBellGroup = (state, { grupo, valor }) => {
  state.bell[grupo] = valor;
  state.bell.consultado[grupo] = Date.now();
};

export const setBellLoading = (state, { grupo, valor }) => {
  state.bell.cargando[grupo] = valor;
};

/**
 * Retira un aviso de agenda de los tres grupos a la vez, tras cumplir la tarea.
 *
 * Va por `source` y no por `key` a propósito: el mismo evento puede estar
 * pintado como `task:<id>` en Seguimiento y como `appointment:<id>` en Para
 * hacer, y «Cumplir» tiene que apagarlo en los dos sitios. Lo avisa la guía de
 * FC-744.
 */
export const removeBellAgendaItem = (state, agendaId) => {
  const id = Number(agendaId);
  const esElEvento = (aviso) =>
    aviso?.source?.model === "Agenda" && Number(aviso?.source?.id) === id;

  ["toDo", "news"].forEach((grupo) => {
    const items = state.bell[grupo].items || [];
    const fuera = items.filter(esElEvento);
    if (!fuera.length) return;
    state.bell[grupo] = {
      items: items.filter((aviso) => !esElEvento(aviso)),
      total: Math.max(0, state.bell[grupo].total - fuera.length),
      urgent: Math.max(
        0,
        state.bell[grupo].urgent - fuera.filter((a) => a.priority === "urgent").length
      ),
    };
  });

  const vencidas = state.bell.followUp.overdue_tasks;
  const fuera = (vencidas.items || []).filter(esElEvento);
  if (fuera.length) {
    state.bell.followUp = {
      ...state.bell.followUp,
      overdue_tasks: {
        items: vencidas.items.filter((aviso) => !esElEvento(aviso)),
        total: Math.max(0, vencidas.total - fuera.length),
      },
    };
  }
};
